import { Injectable } from '@angular/core';
import { FormDefinition } from '../components/shared/form-designer/models/form.model';

@Injectable({
  providedIn: 'root'
})
export class FormDesignerPreviewService {

  /**
   * Open preview in new window/tab using FormDefinition directly
   */
  openPreview(formDefinition: FormDefinition): void {
    // Use sessionStorage to pass data (supports larger forms than URL params)
    const previewData = {
      formDefinition: formDefinition,
      timestamp: Date.now()
    };

    const sessionKey = `form_preview_${Date.now()}`;
    sessionStorage.setItem(sessionKey, JSON.stringify(previewData));

    // Open new window with session key
    const previewUrl = `/admin/form-builder/preview?session=${sessionKey}`;
    window.open(previewUrl, '_blank', 'width=1200,height=800,scrollbars=yes,resizable=yes');
  }

  /**
   * Get form definition from session storage
   */
  getFormDefinitionFromSession(sessionKey: string): FormDefinition | null {
    try {
      const data = sessionStorage.getItem(sessionKey);
      if (data) {
        const previewData = JSON.parse(data);
        return previewData.formDefinition;
      }
    } catch (error) {
      console.error('Failed to load preview data from session:', error);
    }
    return null;
  }

  /**
   * Clean up session data
   */
  cleanupSession(sessionKey: string): void {
    sessionStorage.removeItem(sessionKey);
  }
}
